import { computed } from 'vue'
import { usePlantilla } from './usePlantilla'
import { useStore } from '../store/index'
import { CORREO_MINOTARIA } from '../plantillas/minotaria'

// "Teléfono: 900 732 022<br>" y variantes: en minotaria.es se quita la línea entera
const TELEFONO = /(?:Tel[ée]fono|Tfno\.?|Tel\.)\s*:?\s*(?:&nbsp;)?\s*\+?[\d][\d\s.]{6,}\d\s*(?:<br\s*\/?>)?/gi
const CORREO = /[\w.+-]+@[\w-]+(?:\.[\w-]+)+/g
/** Delegado de Protección de Datos: el mismo para las webs y para minotaria.es. */
const CORREO_DPO = 'unidata@consultoresrgpd.es'
const ES_CORREO_DPO = /@consultoresrgpd\.es$/i
/** minotaria.es no puede mostrar ninguna relación con Notin: sus correos nunca salen en la web. */
const ES_CORREO_NOTIN = /@notin\.(?:net|es|com)$/i

/**
 * Correos de las páginas legales (aviso legal, privacidad, cookies, accesibilidad).
 * minotaria.es: sin teléfonos; el correo que se escriba en el texto del panel se respeta, salvo los de Notin (se cambian
 * por el de contacto) y el del DPO (siempre el de Unidata). Ref: https://trello.com/c/8j6VOWgP https://trello.com/c/7dutu342
 */
export function useContactoLegal() {
  const { plantilla } = usePlantilla()
  const store = useStore()
  const esMinotaria = computed(() => plantilla.value.nombre === 'minotaria')
  // minotaria.es: el email de contacto del panel; el fijo si el panel no tiene ninguno o es de Notin. Ref: https://trello.com/c/2DKePjFr
  const correoMinotaria = computed(() => {
    const email = ((store.NOTARIA as any)?.Contacto?.Email || '').trim()
    return email && !ES_CORREO_NOTIN.test(email) ? email : CORREO_MINOTARIA
  })
  const correo = computed(() => (esMinotaria.value ? correoMinotaria.value : 'web@unidata.es'))
  const correoDpo = computed(() => CORREO_DPO)
  /** Texto legal del panel tal cual o, en minotaria.es, sin teléfonos, con el correo del DPO y sin correos de Notin. */
  const htmlLegal = (html: string | null | undefined) =>
    !html || !esMinotaria.value ? html
      : html.replace(TELEFONO, '').replace(CORREO, (c) =>
        ES_CORREO_DPO.test(c) ? CORREO_DPO : ES_CORREO_NOTIN.test(c) ? correoMinotaria.value : c)
  return { esMinotaria, correo, correoDpo, htmlLegal }
}
